import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

export enum ActivityFields {
    SUBJECT = 'subject',
    MAIN_PRODUCT = 'mainProduct',
    MAIN_PRODUCT_GROSS_PRICE = 'mainProductGrossPrice',
    MAIN_PRODUCT_VAT_PERCENT = 'mainProductVatPercent',
    MAIN_PRODUCT_NET_PRICE = 'mainProductNetPrice',
    SERIES_SUBSCRIPTIONS = 'seriesSubscriptions',
    IMAGE = 'image',
    TITLE = 'title',
    PRODUCT_SELECTIONS = 'productSelections',
    IS_ACTIVE = 'isActive',
    CREATED_AT = 'createdAt',
    UPDATED_AT = 'updatedAt',
}

export namespace ActivityFields {
    type Data = {
        text: string;
        readOnly?: true;
        updateOnly?: true;
    }

    export const Record: Record<ActivityFields, Data> = {
        [ActivityFields.SUBJECT]: {
            text: 'Fach',
        },
        [ActivityFields.MAIN_PRODUCT]: {
            text: 'Hauptprodukt',
        },
        [ActivityFields.MAIN_PRODUCT_GROSS_PRICE]: {
            text: 'Bruttopreis Hauptprodukt',
        },
        [ActivityFields.MAIN_PRODUCT_VAT_PERCENT]: {
            text: 'Mehrwertsteuersatz Hauptprodukt',
        },
        [ActivityFields.MAIN_PRODUCT_NET_PRICE]: {
            text: 'Nettopreis Hauptprodukt',
        },
        [ActivityFields.SERIES_SUBSCRIPTIONS]: {
            text: 'Serienabonnements',
        },
        [ActivityFields.IMAGE]: {
            text: 'Bild',
        },
        [ActivityFields.TITLE]: {
            text: 'Titel',
        },
        [ActivityFields.PRODUCT_SELECTIONS]: {
            text: 'Produktauswahl',
        },
        [ActivityFields.IS_ACTIVE]: {
            text: 'Aktiv',
        },
        [ActivityFields.CREATED_AT]: {
            text: 'Erzeugungsdatum',
            readOnly: true,
        },
        [ActivityFields.UPDATED_AT]: {
            text: 'Änderungsdatum',
            readOnly: true,
        },
    }

    export const Items = mapRecordToItems(Record);
}
